import { ProjectRoles, WorkspaceUserRoles } from './enums';
export const enumColors = {
    light: [
        '#cfdffe',
        '#d0f1fd',
        '#c2f5e8',
        '#ffdaf6',
        '#ffdce5',
        '#fee2d5',
        '#ffeab6',
        '#d1f7c4',
        '#ede2fe',
        '#eeeeee',
    ],
    dark: [
        '#2d7ff999',
        '#18bfff99',
        '#20d9d299',
        '#ff08c299',
        '#f82b6099',
        '#ff6f2c99',
        '#fcb40099',
        '#20c93399',
        '#8b46ff99',
        '#666',
    ],
    get: (theme, index) => {
        index = Math.abs(index) % enumColors[theme].length;
        return enumColors[theme][index];
    },
};
export var ViewTypes;
(function (ViewTypes) {
    ViewTypes[ViewTypes["FORM"] = 1] = "FORM";
    ViewTypes[ViewTypes["GALLERY"] = 2] = "GALLERY";
    ViewTypes[ViewTypes["GRID"] = 3] = "GRID";
    ViewTypes[ViewTypes["KANBAN"] = 4] = "KANBAN";
    ViewTypes[ViewTypes["MAP"] = 5] = "MAP";
    ViewTypes[ViewTypes["CALENDAR"] = 6] = "CALENDAR";
    ViewTypes[ViewTypes["LIST"] = 7] = "LIST";
    ViewTypes[ViewTypes["TIMELINE"] = 8] = "TIMELINE";
    ViewTypes[ViewTypes["GANTT"] = 9] = "GANTT";
})(ViewTypes || (ViewTypes = {}));
export const viewTypeAlias = {
    [ViewTypes.FORM]: 'form',
    [ViewTypes.GALLERY]: 'gallery',
    [ViewTypes.GRID]: 'grid',
    [ViewTypes.KANBAN]: 'kanban',
    [ViewTypes.MAP]: 'map',
    [ViewTypes.CALENDAR]: 'calendar',
    [ViewTypes.LIST]: 'list',
    [ViewTypes.TIMELINE]: 'timeline',
    [ViewTypes.GANTT]: 'gantt',
};
export const viewTypeToStringMap = Object.assign({}, viewTypeAlias);
// Generate reverse mapping from the original viewTypeAlias
export const stringToViewTypeMap = Object.entries(viewTypeAlias).reduce((acc, [key, value]) => {
    acc[value] = Number(key);
    return acc;
}, {});
export const VIEW_GRID_DEFAULT_WIDTH = 200;
export var ProjectTypes;
(function (ProjectTypes) {
    ProjectTypes["DATABASE"] = "database";
    ProjectTypes["DOCUMENTATION"] = "documentation";
    ProjectTypes["COWRITER"] = "cowriter";
    ProjectTypes["DASHBOARD"] = "dashboard";
})(ProjectTypes || (ProjectTypes = {}));
export var RelationTypes;
(function (RelationTypes) {
    RelationTypes["HAS_MANY"] = "hm";
    RelationTypes["BELONGS_TO"] = "bt";
    RelationTypes["MANY_TO_MANY"] = "mm";
    RelationTypes["ONE_TO_ONE"] = "oo";
    RelationTypes["ONE_TO_MANY"] = "om";
    RelationTypes["MANY_TO_ONE"] = "mo";
})(RelationTypes || (RelationTypes = {}));
export var LinksVersion;
(function (LinksVersion) {
    LinksVersion[LinksVersion["V1"] = 1] = "V1";
    LinksVersion[LinksVersion["V2"] = 2] = "V2";
})(LinksVersion || (LinksVersion = {}));
export const ExpandedFormMode = {
    FIELD: 'field',
    ATTACHMENT: 'attachment',
    DISCUSSION: 'discussion',
};
export var ExportTypes;
(function (ExportTypes) {
    ExportTypes["EXCEL"] = "excel";
    ExportTypes["CSV"] = "csv";
    ExportTypes["JSON"] = "json";
})(ExportTypes || (ExportTypes = {}));
export var PluginCategory;
(function (PluginCategory) {
    PluginCategory["STORAGE"] = "Storage";
    PluginCategory["EMAIL"] = "Email";
})(PluginCategory || (PluginCategory = {}));
export var ModelTypes;
(function (ModelTypes) {
    ModelTypes["TABLE"] = "table";
    ModelTypes["VIEW"] = "view";
    ModelTypes["DASHBOARD"] = "dashboard";
    ModelTypes["DOCUMENT"] = "document";
})(ModelTypes || (ModelTypes = {}));
export var AutomationTypes;
(function (AutomationTypes) {
    AutomationTypes["SCRIPT"] = "script";
    AutomationTypes["WORKFLOW"] = "workflow";
})(AutomationTypes || (AutomationTypes = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["JOB"] = "job";
})(ProjectStatus || (ProjectStatus = {}));
export var TiptapNodesTypes;
(function (TiptapNodesTypes) {
    TiptapNodesTypes["doc"] = "doc";
    TiptapNodesTypes["sec"] = "sec";
    TiptapNodesTypes["paragraph"] = "paragraph";
    TiptapNodesTypes["text"] = "text";
    TiptapNodesTypes["heading"] = "heading";
    TiptapNodesTypes["bullet"] = "bullet";
    TiptapNodesTypes["ordered"] = "ordered";
    TiptapNodesTypes["task"] = "task";
    TiptapNodesTypes["quote"] = "quote";
    TiptapNodesTypes["divider"] = "divider";
    TiptapNodesTypes["codeBlock"] = "codeBlock";
    TiptapNodesTypes["image"] = "image";
    TiptapNodesTypes["callout"] = "callout";
    TiptapNodesTypes["tipCallout"] = "tipCallout";
    TiptapNodesTypes["table"] = "table";
    TiptapNodesTypes["tableRow"] = "tableRow";
    TiptapNodesTypes["tableCell"] = "tableCell";
    TiptapNodesTypes["embed"] = "embed";
    TiptapNodesTypes["collapsable"] = "collapsable";
    TiptapNodesTypes["collapsableContent"] = "collapsable_content";
    TiptapNodesTypes["collapsableHeader"] = "collapsable_header";
    TiptapNodesTypes["column"] = "column";
    TiptapNodesTypes["columnContent"] = "columnContent";
    TiptapNodesTypes["linkToPage"] = "linkToPage";
    TiptapNodesTypes["attachment"] = "attachment";
})(TiptapNodesTypes || (TiptapNodesTypes = {}));
export var TiptapMarksTypes;
(function (TiptapMarksTypes) {
    TiptapMarksTypes["strike"] = "strike";
    TiptapMarksTypes["bold"] = "bold";
    TiptapMarksTypes["italic"] = "italic";
    TiptapMarksTypes["link"] = "link";
    TiptapMarksTypes["code"] = "code";
    TiptapMarksTypes["underline"] = "underline";
})(TiptapMarksTypes || (TiptapMarksTypes = {}));
export var NcDataErrorCodes;
(function (NcDataErrorCodes) {
    NcDataErrorCodes["NC_ERR_MM_MODEL_NOT_FOUND"] = "NC_ERR_MM_MODEL_NOT_FOUND";
})(NcDataErrorCodes || (NcDataErrorCodes = {}));
export const NC_ERROR_SENTINEL = '_____NC_ERROR_____';
export var NcErrorType;
(function (NcErrorType) {
    NcErrorType["ERR_AUTHENTICATION_REQUIRED"] = "ERR_AUTHENTICATION_REQUIRED";
    NcErrorType["ERR_FORBIDDEN"] = "ERR_FORBIDDEN";
    NcErrorType["ERR_API_TOKEN_NOT_ALLOWED"] = "ERR_API_TOKEN_NOT_ALLOWED";
    NcErrorType["ERR_WORKSPACE_NOT_FOUND"] = "ERR_WORKSPACE_NOT_FOUND";
    NcErrorType["ERR_BASE_NOT_FOUND"] = "ERR_BASE_NOT_FOUND";
    NcErrorType["ERR_SOURCE_NOT_FOUND"] = "ERR_SOURCE_NOT_FOUND";
    NcErrorType["ERR_TABLE_NOT_FOUND"] = "ERR_TABLE_NOT_FOUND";
    NcErrorType["ERR_VIEW_NOT_FOUND"] = "ERR_VIEW_NOT_FOUND";
    NcErrorType["ERR_FIELD_NOT_FOUND"] = "ERR_FIELD_NOT_FOUND";
    NcErrorType["ERR_RECORD_NOT_FOUND"] = "ERR_RECORD_NOT_FOUND";
    NcErrorType["ERR_TABLE_TRASH_NOT_SUPPORTED"] = "ERR_TABLE_TRASH_NOT_SUPPORTED";
    NcErrorType["ERR_RECORD_RESTORE_CONFLICT"] = "ERR_RECORD_RESTORE_CONFLICT";
    NcErrorType["ERR_RECORD_NOT_TRASHED"] = "ERR_RECORD_NOT_TRASHED";
    NcErrorType["ERR_TRASH_BATCH_LIMIT_EXCEEDED"] = "ERR_TRASH_BATCH_LIMIT_EXCEEDED";
    NcErrorType["ERR_GENERIC_NOT_FOUND"] = "ERR_GENERIC_NOT_FOUND";
    NcErrorType["ERR_HOOK_NOT_FOUND"] = "ERR_HOOK_NOT_FOUND";
    NcErrorType["ERR_REQUIRED_FIELD_MISSING"] = "ERR_REQUIRED_FIELD_MISSING";
    NcErrorType["ERR_DUPLICATE_RECORD"] = "ERR_DUPLICATE_RECORD";
    NcErrorType["ERR_USER_NOT_FOUND"] = "ERR_USER_NOT_FOUND";
    NcErrorType["ERR_TEAM_NOT_FOUND"] = "ERR_TEAM_NOT_FOUND";
    NcErrorType["ERR_INVALID_OFFSET_VALUE"] = "ERR_INVALID_OFFSET_VALUE";
    NcErrorType["ERR_INVALID_PAGE_VALUE"] = "ERR_INVALID_PAGE_VALUE";
    NcErrorType["ERR_INVALID_LIMIT_VALUE"] = "ERR_INVALID_LIMIT_VALUE";
    NcErrorType["ERR_INVALID_FILTER"] = "ERR_INVALID_FILTER";
    NcErrorType["ERR_INVALID_SHARED_VIEW_PASSWORD"] = "ERR_INVALID_SHARED_VIEW_PASSWORD";
    NcErrorType["ERR_INVALID_ATTACHMENT_JSON"] = "ERR_INVALID_ATTACHMENT_JSON";
    NcErrorType["ERR_NOT_IMPLEMENTED"] = "ERR_NOT_IMPLEMENTED";
    NcErrorType["ERR_INTERNAL_SERVER"] = "ERR_INTERNAL_SERVER";
    NcErrorType["ERR_DATABASE_OP_FAILED"] = "ERR_DATABASE_OP_FAILED";
    NcErrorType["ERR_UNKNOWN"] = "ERR_UNKNOWN";
    NcErrorType["ERR_INVALID_JSON"] = "ERR_INVALID_JSON";
    NcErrorType["ERR_INVALID_PK_VALUE"] = "ERR_INVALID_PK_VALUE";
    NcErrorType["ERR_COLUMN_ASSOCIATED_WITH_LINK"] = "ERR_COLUMN_ASSOCIATED_WITH_LINK";
    NcErrorType["ERR_TABLE_ASSOCIATED_WITH_LINK"] = "ERR_TABLE_ASSOCIATED_WITH_LINK";
    NcErrorType["ERR_INTEGRATION_NOT_FOUND"] = "ERR_INTEGRATION_NOT_FOUND";
    NcErrorType["ERR_INTEGRATION_LINKED_WITH_BASES"] = "ERR_INTEGRATION_LINKED_WITH_BASES";
    NcErrorType["ERR_FORMULA"] = "ERR_FORMULA";
    NcErrorType["ERR_CIRCULAR_REF_IN_FORMULA"] = "ERR_CIRCULAR_REF_IN_FORMULA";
    NcErrorType["ERR_PERMISSION_DENIED"] = "ERR_PERMISSION_DENIED";
    NcErrorType["ERR_INVALID_ATTACHMENT_UPLOAD_SCOPE"] = "ERR_INVALID_ATTACHMENT_UPLOAD_SCOPE";
    NcErrorType["ERR_CANNOT_CALCULATE_INTERMEDIATE_ORDER"] = "ERR_CANNOT_CALCULATE_INTERMEDIATE_ORDER";
    NcErrorType["ERR_REORDER_FAILED"] = "ERR_REORDER_FAILED";
    NcErrorType["ERR_PLAN_LIMIT_EXCEEDED"] = "ERR_PLAN_LIMIT_EXCEEDED";
    NcErrorType["ERR_FEATURE_NOT_SUPPORTED"] = "ERR_FEATURE_NOT_SUPPORTED";
    NcErrorType["ERR_SSO_LOGIN_REQUIRED"] = "ERR_SSO_LOGIN_REQUIRED";
    NcErrorType["ERR_SSO_GENERATED_TOKEN_REQUIRED"] = "ERR_SSO_GENERATED_TOKEN_REQUIRED";
    NcErrorType["ERR_MFA_SETUP_REQUIRED"] = "ERR_MFA_SETUP_REQUIRED";
    NcErrorType["ERR_MAX_PAYLOAD_LIMIT_EXCEEDED"] = "ERR_MAX_PAYLOAD_LIMIT_EXCEEDED";
    NcErrorType["ERR_INVALID_VALUE_FOR_FIELD"] = "ERR_INVALID_VALUE_FOR_FIELD";
    NcErrorType["ERR_MAX_WORKSPACE_LIMIT_REACHED"] = "ERR_MAX_WORKSPACE_LIMIT_REACHED";
    NcErrorType["ERR_BASE_COLLABORATION"] = "ERR_BASE_COLLABORATION";
    NcErrorType["ERR_ORG_USER"] = "ERR_ORG_USER";
    NcErrorType["ERR_SYNC_TABLE_OPERATION_PROHIBITED"] = "ERR_SYNC_TABLE_OPERATION_PROHIBITED";
    NcErrorType["ERR_INVALID_REQUEST_BODY"] = "ERR_INVALID_REQUEST_BODY";
    NcErrorType["ERR_TRASH_NOT_FOUND"] = "ERR_TRASH_NOT_FOUND";
    NcErrorType["ERR_PARENT_IN_TRASH"] = "ERR_PARENT_IN_TRASH";
    NcErrorType["ERR_DASHBOARD_NOT_FOUND"] = "ERR_DASHBOARD_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_NOT_FOUND"] = "ERR_WORKFLOW_NOT_FOUND";
    NcErrorType["ERR_WIDGET_NOT_FOUND"] = "ERR_WIDGET_NOT_FOUND";
    NcErrorType["ERR_CHAT_SESSION_NOT_FOUND"] = "ERR_CHAT_SESSION_NOT_FOUND";
    NcErrorType["ERR_CHAT_MESSAGE_NOT_FOUND"] = "ERR_CHAT_MESSAGE_NOT_FOUND";
    NcErrorType["ERR_VIEW_SECTION_NOT_FOUND"] = "ERR_VIEW_SECTION_NOT_FOUND";
    NcErrorType["ERR_SHARED_DASHBOARD_PASSWORD_INVALID"] = "ERR_SHARED_DASHBOARD_PASSWORD_INVALID";
    NcErrorType["ERR_DUPLICATE_IN_ALIAS"] = "ERR_DUPLICATE_IN_ALIAS";
    NcErrorType["ERR_OUT_OF_SYNC"] = "ERR_OUT_OF_SYNC";
    NcErrorType["ERR_FILTER_VERIFICATION_FAILED"] = "ERR_FILTER_VERIFICATION_FAILED";
    NcErrorType["ERR_VIEW_COLUMN_NOT_FOUND"] = "ERR_VIEW_COLUMN_NOT_FOUND";
    NcErrorType["ERR_WEBHOOK_ERROR"] = "ERR_WEBHOOK_ERROR";
    NcErrorType["ERR_WEBHOOK_URL_INVALID"] = "ERR_WEBHOOK_URL_INVALID";
    NcErrorType["ERR_BASE_OP_FAILED"] = "ERR_BASE_OP_FAILED";
    NcErrorType["ERR_TABLE_OP_FAILED"] = "ERR_TABLE_OP_FAILED";
    NcErrorType["ERR_COLUMN_OP_FAILED"] = "ERR_COLUMN_OP_FAILED";
    NcErrorType["ERR_DATA_SOURCES_NOT_FOUND"] = "ERR_DATA_SOURCES_NOT_FOUND";
    NcErrorType["ERR_TEST_PLUGIN_FAILED"] = "ERR_TEST_PLUGIN_FAILED";
    NcErrorType["ERR_UNSUPPORTED_RELATION"] = "ERR_UNSUPPORTED_RELATION";
    NcErrorType["ERR_IN_EXTERNAL_DATA_SOURCE"] = "ERR_IN_EXTERNAL_DATA_SOURCE";
    NcErrorType["ERR_EXTERNAL_DATA_SOURCE_TIMEOUT"] = "ERR_EXTERNAL_DATA_SOURCE_TIMEOUT";
    NcErrorType["ERR_RELATION_FIELD_NOT_FOUND"] = "ERR_RELATION_FIELD_NOT_FOUND";
    NcErrorType["ERR_UNSUPPORTED_FILTER_OPERATION"] = "ERR_UNSUPPORTED_FILTER_OPERATION";
    NcErrorType["ERR_STORAGE_FILE_CREATE"] = "ERR_STORAGE_FILE_CREATE";
    NcErrorType["ERR_STORAGE_FILE_READ"] = "ERR_STORAGE_FILE_READ";
    NcErrorType["ERR_STORAGE_FILE_DELETE"] = "ERR_STORAGE_FILE_DELETE";
    NcErrorType["ERR_STORAGE_FILE_STREAM"] = "ERR_STORAGE_FILE_STREAM";
    NcErrorType["ERR_PLAN_ALREADY_EXISTS"] = "ERR_PLAN_ALREADY_EXISTS";
    NcErrorType["ERR_SUBSCRIPTION_ALREADY_EXISTS"] = "ERR_SUBSCRIPTION_ALREADY_EXISTS";
    NcErrorType["ERR_SUBSCRIPTION_NOT_FOUND"] = "ERR_SUBSCRIPTION_NOT_FOUND";
    NcErrorType["ERR_PLAN_NOT_AVAILABLE"] = "ERR_PLAN_NOT_AVAILABLE";
    NcErrorType["ERR_SEAT_COUNT_MISMATCH"] = "ERR_SEAT_COUNT_MISMATCH";
    NcErrorType["ERR_INVALID_PAYMENT_PAYLOAD"] = "ERR_INVALID_PAYMENT_PAYLOAD";
    NcErrorType["ERR_STRIPE_CUSTOMER_NOT_FOUND"] = "ERR_STRIPE_CUSTOMER_NOT_FOUND";
    NcErrorType["ERR_STRIPE_SUBSCRIPTION_NOT_FOUND"] = "ERR_STRIPE_SUBSCRIPTION_NOT_FOUND";
    NcErrorType["ERR_SUBSCRIPTION_OWNERSHIP_MISMATCH"] = "ERR_SUBSCRIPTION_OWNERSHIP_MISMATCH";
    NcErrorType["ERR_INTERNAL_CUSTOMER_NOT_SUPPORTED"] = "ERR_INTERNAL_CUSTOMER_NOT_SUPPORTED";
    NcErrorType["ERR_SUBSCRIPTION_CREATE_FAILED"] = "ERR_SUBSCRIPTION_CREATE_FAILED";
    NcErrorType["ERR_STRIPE_WEBHOOK_VERIFICATION_FAILED"] = "ERR_STRIPE_WEBHOOK_VERIFICATION_FAILED";
    NcErrorType["ERR_API_CLIENT_NOT_FOUND"] = "ERR_API_CLIENT_NOT_FOUND";
    NcErrorType["ERR_EXTENSION_NOT_FOUND"] = "ERR_EXTENSION_NOT_FOUND";
    NcErrorType["ERR_SCRIPT_NOT_FOUND"] = "ERR_SCRIPT_NOT_FOUND";
    NcErrorType["ERR_RLS_POLICY_NOT_FOUND"] = "ERR_RLS_POLICY_NOT_FOUND";
    NcErrorType["FIELD_UNIQUE_CONSTRAINT_VIOLATION"] = "FIELD_UNIQUE_CONSTRAINT_VIOLATION";
    NcErrorType["ERR_METHOD_NOT_ALLOWED"] = "ERR_METHOD_NOT_ALLOWED";
    NcErrorType["ERR_INSUFFICIENT_PRIVILEGE"] = "ERR_INSUFFICIENT_PRIVILEGE";
    // Workflow Errors
    NcErrorType["ERR_WORKFLOW_EMPTY_NODE"] = "ERR_WORKFLOW_EMPTY_NODE";
    NcErrorType["ERR_WORKFLOW_TRIGGER_NODE_NOT_FOUND"] = "ERR_WORKFLOW_TRIGGER_NODE_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_NODE_EXECUTION_FAILED"] = "ERR_WORKFLOW_NODE_EXECUTION_FAILED";
    NcErrorType["ERR_WORKFLOW_MAX_ITERATIONS_EXCEEDED"] = "ERR_WORKFLOW_MAX_ITERATIONS_EXCEEDED";
    NcErrorType["ERR_WORKFLOW_NODE_NOT_FOUND"] = "ERR_WORKFLOW_NODE_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_WAITING_EXECUTIONS"] = "ERR_WORKFLOW_WAITING_EXECUTIONS";
    // License Errors
    NcErrorType["ERR_LICENSE_REQUIRED"] = "ERR_LICENSE_REQUIRED";
    NcErrorType["ERR_LICENSE_SUSPENDED"] = "ERR_LICENSE_SUSPENDED";
    NcErrorType["ERR_SYSTEM_FIELD_NON_MODIFIABLE"] = "ERR_SYSTEM_FIELD_NON_MODIFIABLE";
    // System configuration errors
    NcErrorType["ERR_SYSTEM_MISCONFIGURED"] = "ERR_SYSTEM_MISCONFIGURED";
    NcErrorType["ERR_TOO_MANY_REQUESTS"] = "ERR_TOO_MANY_REQUESTS";
    // Sandbox errors
    NcErrorType["ERR_SANDBOX_BLOCKED"] = "ERR_SANDBOX_BLOCKED";
    NcErrorType["ERR_SANDBOX_PRODUCTION_BLOCKED"] = "ERR_SANDBOX_PRODUCTION_BLOCKED";
})(NcErrorType || (NcErrorType = {}));
export var ROW_COLORING_MODE;
(function (ROW_COLORING_MODE) {
    ROW_COLORING_MODE["FILTER"] = "filter";
    ROW_COLORING_MODE["SELECT"] = "select";
})(ROW_COLORING_MODE || (ROW_COLORING_MODE = {}));
export var COLORING_TYPE;
(function (COLORING_TYPE) {
    COLORING_TYPE["ROW"] = "row";
    COLORING_TYPE["CELL"] = "cell";
})(COLORING_TYPE || (COLORING_TYPE = {}));
export const LongTextAiMetaProp = 'ai';
export const LongTextRichModeMetaProp = 'richMode';
export const LongTextSmartModeMetaProp = 'smartMode';
export const NO_SCOPE = 'nc';
export const NON_SEAT_ROLES = [
    WorkspaceUserRoles.NO_ACCESS,
    WorkspaceUserRoles.VIEWER,
    WorkspaceUserRoles.INHERIT,
    WorkspaceUserRoles.COMMENTER,
    ProjectRoles.NO_ACCESS,
    ProjectRoles.VIEWER,
    ProjectRoles.INHERIT,
    ProjectRoles.COMMENTER,
];
export const DURATION_TYPE_MAP = {
    0: 'h:mm',
    1: 'h:mm:ss',
    2: 'h:mm:ss.s',
    3: 'h:mm:ss.ss',
    4: 'h:mm:ss.sss',
    'h:mm': 0,
    'h:mm:ss': 1,
    'h:mm:ss.s': 2,
    'h:mm:ss.ss': 3,
    'h:mm:ss.sss': 4,
};
export const CURRENT_USER_TOKEN = '@me';
export var RowHeight;
(function (RowHeight) {
    RowHeight[RowHeight["SHORT"] = 0] = "SHORT";
    RowHeight[RowHeight["MEDIUM"] = 1] = "MEDIUM";
    RowHeight[RowHeight["TALL"] = 2] = "TALL";
    RowHeight[RowHeight["EXTRA"] = 3] = "EXTRA";
})(RowHeight || (RowHeight = {}));
export const RowHeightMap = {
    short: RowHeight.SHORT,
    medium: RowHeight.MEDIUM,
    tall: RowHeight.TALL,
    extra: RowHeight.EXTRA,
    [RowHeight.SHORT]: 'short',
    [RowHeight.MEDIUM]: 'medium',
    [RowHeight.TALL]: 'tall',
    [RowHeight.EXTRA]: 'extra',
};
export var DependencyTableType;
(function (DependencyTableType) {
    DependencyTableType["Column"] = "column";
    DependencyTableType["Model"] = "table";
    DependencyTableType["View"] = "view";
    DependencyTableType["Widget"] = "widget";
    DependencyTableType["Workflow"] = "workflow";
    DependencyTableType["DateDependency"] = "date_dependency";
    DependencyTableType["Bookmark"] = "bookmark";
})(DependencyTableType || (DependencyTableType = {}));
export var BaseVersion;
(function (BaseVersion) {
    BaseVersion[BaseVersion["V2"] = 2] = "V2";
    BaseVersion[BaseVersion["V3"] = 3] = "V3";
})(BaseVersion || (BaseVersion = {}));
export var ManagedAppVersionStatus;
(function (ManagedAppVersionStatus) {
    ManagedAppVersionStatus["DRAFT"] = "draft";
    ManagedAppVersionStatus["PUBLISHED"] = "published";
})(ManagedAppVersionStatus || (ManagedAppVersionStatus = {}));
export var ManagedAppVisibility;
(function (ManagedAppVisibility) {
    ManagedAppVisibility["PUBLIC"] = "public";
    ManagedAppVisibility["PRIVATE"] = "private";
    ManagedAppVisibility["UNLISTED"] = "unlisted";
})(ManagedAppVisibility || (ManagedAppVisibility = {}));
export var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["PENDING"] = "pending";
    DeploymentStatus["IN_PROGRESS"] = "in_progress";
    DeploymentStatus["SUCCESS"] = "success";
    DeploymentStatus["FAILED"] = "failed";
})(DeploymentStatus || (DeploymentStatus = {}));
export var DeploymentType;
(function (DeploymentType) {
    DeploymentType["INSTALL"] = "install";
    DeploymentType["UPDATE"] = "update";
})(DeploymentType || (DeploymentType = {}));
export var BaseVariableInheritance;
(function (BaseVariableInheritance) {
    BaseVariableInheritance["FIXED"] = "fixed";
    BaseVariableInheritance["EDITABLE"] = "editable";
    BaseVariableInheritance["REQUIRED"] = "required";
})(BaseVariableInheritance || (BaseVariableInheritance = {}));
export var BaseVariableValueType;
(function (BaseVariableValueType) {
    BaseVariableValueType["TEXT"] = "text";
    BaseVariableValueType["SECRET"] = "secret";
})(BaseVariableValueType || (BaseVariableValueType = {}));
//# sourceMappingURL=data:application/json;base64,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